
/**
 * Entity which stock user profile & informations 
 */
export class AccessManager {

  /** Store a variable in sessionStorage like a cookie */
  public setdata(name: string, data: any) {
    sessionStorage.setItem(name, JSON.stringify(data))
  }

  getdata(key: string): any {
    try {
      return JSON.parse(sessionStorage.getItem(key) ?? '');
    } catch (err) {
      return null;
    }

  }
  /** remove a data in sessionStorage */
  public deletedata(name: string) {
    sessionStorage.removeItem(name)
  }

}

/**
 * export like a constant this manager for an easier used
 */
export const database: AccessManager = new AccessManager();
